module.exports = __webpack_public_path__ + "static/media/futura-condensed-bold.e132b996.ttf";